import useDomesticHelperFlow from "../../../../hooks/useDomesticHelperFlowSimple";
import useLanguageTranslate from "../../../../hooks/useLanguageTranslate";
import DomesticHelperBottomStickyBtnLayout from "../../layouts/DomesticHelperBottomStickyBtnLayout";
import DomesticHelperJourneyLayout from "../../layouts/DomesticHelperJourneyLayout";

const CoverageCustomization = () => {
  const translate = useLanguageTranslate();
  const { handleNextStep, handlePrevSubstep } = useDomesticHelperFlow();

  return (
    <div className="coverage-customization w-full">
      <DomesticHelperJourneyLayout
        is_hide_back_btn={false}
        customBackHandler={handlePrevSubstep}
      >
        <div className="content min-w-[32%] max767:w-full">
          <h1 className="text-[#1A2024] text-2xl not-italic font-semibold leading-8 tracking-[-0.24px] text-center max767:text-left">
            {translate("Coverage Options", "خيارات التغطية")}
          </h1>
          <p className="text-[#1A2024] text-base not-italic font-normal leading-6 tracking-[-0.16px] text-center mt-1 mb-6 max767:text-left">
            {translate(
              "Customize your coverage with additional options",
              "خصص تغطيتك بخيارات إضافية"
            )}
          </p>
        </div>
        <DomesticHelperBottomStickyBtnLayout
          show_summary={false}
          btn_onClick={handleNextStep}
        >
          <div className="w-[32%] max767:w-full mx-auto ipad:w-[60%] p-8 text-center">
            <p className="text-gray-600">
              Coverage customization coming soon...
            </p>
            <p className="text-sm text-gray-500 mt-2">
              Medical limits, repatriation, personal accident, add-ons
            </p>
          </div>
        </DomesticHelperBottomStickyBtnLayout>
      </DomesticHelperJourneyLayout>
    </div>
  );
};

export default CoverageCustomization;
